export function trigger() {
  const triggerNav = document.querySelector('.trigger-nav');
  if(triggerNav) {
    triggerNav.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove('is-exhibitors-filter-active');
      if(!document.body.classList.contains('is-nav-active')){
        document.body.classList.add('is-nav-active');
      } else {
        document.body.classList.remove('is-nav-active');
      }
    });
  }

  const triggerFilterExhibitor = document.querySelector('.trigger-filter-exhibitor');
  if(triggerFilterExhibitor) {
    triggerFilterExhibitor.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove('is-nav-active');
      if(!document.body.classList.contains('is-exhibitors-filter-active')){
        document.body.classList.add('is-exhibitors-filter-active');
      } else {
        document.body.classList.remove('is-exhibitors-filter-active');
      }
    });
  }

  const drawers = document.querySelectorAll('.js-drawer');
  const triggerDrawers = document.querySelectorAll('.js-drawer-trigger');
  if (triggerDrawers.length) {
    triggerDrawers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        const triggerName = el.getAttribute('data-drawer');
        if (triggerName) {
          if (!document.body.classList.contains('is-drawer-active')) {
            if (drawers.length) {
              drawers.forEach(function (_el) {
                const drawerName = _el.getAttribute('data-drawer');
                if (drawerName && triggerName == drawerName) {
                  document.body.classList.add('is-drawer-active');
                  _el.classList.add('is-active')
                } else {
                  _el.classList.remove('is-active')
                }
              });
            }
          } else {
            document.body.classList.remove('is-drawer-active');
            if (drawers.length) {
              drawers.forEach(function (_el) {
                _el.classList.remove('is-active')
              });
            }
          }
          e.preventDefault();
        }
      });
    });
  }

  const triggerReset = document.querySelectorAll('.trigger-reset');
  if(triggerReset.length) {
    triggerReset.forEach((el) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.remove('is-nav-active', 'is-exhibitors-filter-active', 'is-drawer-active');
      });
    })
  }
}